// Raw color values for programmatic use (styled components, etc.)

const palette = {
  // New custom purple scale based on your brand colors
  purple: {
    50: '#FAF5FF', // Very light purple (for text on dark backgrounds)
    100: '#F3E8FF', // Light purple (primary text on dark)
    200: '#E9D5FF', // Lighter purple (secondary text)
    300: '#D8B4FE', // Medium light purple (muted text)
    400: '#C084FC', // Medium purple (accent elements)
    500: '#520380', // Main & highlight color (primary buttons, links)
    600: '#3a025b', // Secondary card backgrounds (not onboarding steps)
    700: '#1a0129', // In-between dark/highlight color (hover states)
    800: '#220135', // Footer background (darker elements)
    900: '#11001c', // Landing page & onboarding background (darkest)
    950: '#0a0013', // Ultra dark (shadows, deep backgrounds)
  },

  // Semantic color mapping
  brand: {
    primary: '#520380', // Main & highlight color
    secondary: '#3a025b', // Secondary card backgrounds (not onboarding steps)
    tertiary: '#1a0129', // In-between dark/highlight color
  },

  backgrounds: {
    landing: '#11001c', // Landing page background
    onboarding: '#11001c', // Behind onboarding steps
    stepCard: '#220135', // Onboarding step background (darker footer color)
    footer: '#1a0129', // Footer bottom bar background
    modal: '#1a0129', // Modal backgrounds
    card: '#3a025b', // General card backgrounds
  },

  // Standard colors
  white: '#FFFFFF',
  black: '#000000',
  transparent: 'transparent',

  // Neutral grays that work with the purple theme
  gray: {
    50: '#F8F9FA',
    100: '#F1F3F4',
    200: '#E8EAED',
    300: '#DADCE0',
    400: '#BDC1C6',
    500: '#9AA0A6',
    600: '#80868B',
    700: '#5F6368',
    800: '#3C4043',
    900: '#202124',
  },
};

export const tableHeaderBackground = palette.purple[300]; // Lighter purple for table headers

export default palette;
